import { Descriptions } from 'antd';
import { VFC } from 'react';
import { ImageUploadReview } from 'components/ImageUpload/ImageUploadReview';
import { FormattedMessage, useIntl } from 'react-intl';
import { InstallationMeterRegisterFormValues } from '../installation_detail/slice';
import { RegisterDescriptions as messages } from './messages';

export interface RegisterDescriptionsProps {
  register: InstallationMeterRegisterFormValues;
  order: number;
}

export const RegisterDescriptions: VFC<RegisterDescriptionsProps> = ({ order, register }) => {
  const { name, obis, tariff, factor, channel, counter, counterPhotos } = register;
  const intl = useIntl();
  return (
    <Descriptions
      bordered
      column={1}
      size="small"
      title={
        <>
          {intl.formatMessage(messages.title)} {order}
        </>
      }
    >
      <Descriptions.Item label={<FormattedMessage {...messages.nameObis} />} span={1}>
        <>
          {name && name}{' '}
          {obis && (
            <>
              ({obis}.{tariff ?? 0})
            </>
          )}
        </>
      </Descriptions.Item>
      <Descriptions.Item label={<FormattedMessage {...messages.factor} />} span={1}>
        {factor}
      </Descriptions.Item>
      <Descriptions.Item label={<FormattedMessage {...messages.inputChannel} />} span={1}>
        {channel}
      </Descriptions.Item>
      <Descriptions.Item label={<FormattedMessage {...messages.counter} />} span={1}>
        {counter}
      </Descriptions.Item>
      <Descriptions.Item label={<FormattedMessage {...messages.registerPhotos} />} span={1}>
        <ImageUploadReview fileList={counterPhotos} />
      </Descriptions.Item>
    </Descriptions>
  );
};
